// LoadingAnimation.tsx
import { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import styled from "styled-components";
import MLPLogo from "../imgs/my-life-plan.png";

const LoadingAnimation = ({
  loading,
  onComplete,
}: {
  loading?: boolean;
  onComplete: any;
}) => {
  const growDotControls = useAnimation();

  // Shorter distance to match logo text width more closely
  const bounceKeyframes = {
    x: [0, 40, 80, 120, 160, 200],
    y: [0, -40, 0, -30, 0, -20, 0, -10, 0, -5, 0],
  };

  useEffect(() => {
    if (!loading) {
      growDotControls
        .start({
          x: "-50%",
          y: "-50%",
          width: 160,
          height: 160,
          backgroundColor: "#243aff",
          transition: {
            duration: 1,
            ease: "easeInOut",
          },
        })
        .then(() => {
          growDotControls.start({
            width: 80,
            height: 80,
            transition: {
              duration: 0.6,
              ease: "easeOut",
            },
          });
          setTimeout(() => onComplete(), 2000);
        });
    }

    return () => {};
  }, [loading, growDotControls, onComplete]);

  return (
    <Wrapper className="hide-on-large-only">
      <h1 className="logo-text">
        <img
          className={`animate__animated ${loading ? "" : "animate__fadeOut"}`}
          src={MLPLogo}
          alt="my life plan"
        />
        <span>.</span>
      </h1>

      {loading ? (
        <motion.div
          className="dot"
          animate={bounceKeyframes}
          transition={{
            duration: 2.5,
            ease: "easeInOut",
            times: [0, 0.2, 0.4, 0.6, 0.8, 1],
            repeat: Infinity,
            repeatDelay: 2,
            repeatType: "loop",
          }}
        />
      ) : (
        // <motion.div
        //   className="grow-dot"
        //   initial={{
        //     width: 12,
        //     height: 12,
        //     backgroundColor: "#000",
        //     borderRadius: "50%",
        //     position: "absolute",
        //     top: "50%",
        //     left: "calc(50% + 100px)",
        //     x: 0,
        //     y: 0,
        //   }}
        //   animate={growDotControls}
        // />
        <></>
      )}
    </Wrapper>
  );
};

export default LoadingAnimation;

const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;

  .dot {
    width: 12px;
    height: 12px;
    background: #000;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: calc(50% - 100px);
    transform: translateY(-50%);
    box-shadow: -3px 8px 11px 0px rgba(0, 0, 0, 0.75);

    @media (max-width: 768px) {
      left: calc(50% - 75px);
    }

    @media (max-width: 480px) {
      left: calc(50% - 60px);
    }
  }

  .grow-dot {
    border-radius: 50%;
    position: absolute;
    box-shadow: 0 8px 24px rgba(36, 58, 255, 0.3);
  }

  img {
    max-width: 570px;
    margin-top: -21px;
    margin-left: -100px;
  }

  span {
    color: transparent;
  }

  @media only screen and (max-width: 650px) {
    img {
      max-width: 408px;
      margin-top: 40px;
      margin-left: -15px;
    }
  }
`;
